/* This file is autogenerated, see readme.md for instructions */
import ContextualPersonalizationSvgIcon from '@bloomreach/banana-theme/icons/contextual-personalization.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ContextualPersonalizationIcon = forwardRef(
  (props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
    return (
      <Icon {...props} ref={forwardedRef}>
        <ContextualPersonalizationSvgIcon />
      </Icon>
    );
  },
);

ContextualPersonalizationIcon.displayName = 'ContextualPersonalizationIcon';

export default ContextualPersonalizationIcon;
